import Application from '@/components/page/Application';
import Instance from '@/components/page/Instance';
import Settings from '@/components/page/Settings';
import Login from '@/components/page/Login';
// Routes
const routes = [
    {
        path: '/',
        name: 'application-list',
        component: Application
    },
    {
        path: '/instances/:applicationUid',
        name: 'instances',
        component: Instance
    },
    {
        path: '/settings',
        name: 'settings',
        component: Settings
    }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/routes.js